export interface ClaimEstateStatus {
  index: number;
  value: string;
  text: string;
}

export const claimEstatesStatusEnum: ClaimEstateStatus[] = [
  { index: 10, value: 'RETURN_BILL', text: 'Boleto Devolutivo' },
  { index: 5, value: 'DEBT_CONFESSION', text: 'Confissão de Dívida' },
  { index: 0, value: 'CREATED', text: 'Em aberto' },
  { index: 6, value: 'IN_ACCORD', text: 'Em acordo' },
  { index: 1, value: 'IN_ANALYSIS', text: 'Em análise' },
  { index: 2, value: 'IN_PROGRESS', text: 'Em andamento' },
  { index: 4, value: 'FINISHED', text: 'Finalizado' },
  { index: 7, value: 'MONTHLY_INDEMNITY', text: 'Indenizado mensalmente' },
  { index: 8, value: 'LMI_LMG_REACHED', text: 'LMI/LMG atingido' },
  { index: 3, value: 'PENDING', text: 'Pendenciado' },
  { index: 9, value: 'PRE_ACCIDENT', text: 'Pré-sinistro' }
];

export const getClaimEstatesStatusText = (value: string): string => {
  const status = claimEstatesStatusEnum.find(item => item.value === value);
  return status ? status.text : 'Status Desconhecido';
};
